/**
 * @license @tabler/icons-react v3.17.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitResistor = createReactComponent("outline", "circuit-resistor", "IconCircuitResistor", [["path", { "d": "M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5", "key": "svg-0" }]]);

export { IconCircuitResistor as default };
//# sourceMappingURL=IconCircuitResistor.mjs.map
